import React, { FC, PropsWithChildren } from "react";
import { useDrawerState } from "shared/hooks/useDrawerState";
import useToggle from "shared/hooks/useToggle";
import { createContext } from "shared/utils/context";
import { MetadataTagsPageType } from "./types";

const [Provider, useMetadataTagsPage] = createContext<MetadataTagsPageType>({
  name: "MetadataTagsPageContext",
  hookName: "useMetatadaTagsPage",
  providerName: "MetadataTagsPageProvider",
});

const MetadataTagsPageProvider: FC<PropsWithChildren> = ({ children }) => {
  const metadataTagDetailsDrawer = useDrawerState<string>();
  const [openModal, setOpenModal] = useToggle(false);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    metadataTagDetailsDrawer,
    openModal,
    setOpenModal,
  };

  return <Provider value={value}>{children}</Provider>;
};

export { MetadataTagsPageProvider, useMetadataTagsPage };
